import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Typography from '../../../../UniformComponents/Typography'
import NoChartData from './NoChartData'
import FilterPill from './FilterPill'
import FilterBreakdownPopover from './FilterBreakdownPopover'
import { getPopoverPlacement, ICON_ONLY_TEMPLATES, countFilterRules } from './popoverPlacement'

import '../../ppbuilder.scss'

const ChartSlot = observer(({ store, position }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)
    const data = store.getChartDataForQuestion(`${question?.surveyId}-${question?.questionId}`, position)
    const template = slide?.template
    const pillMode = ICON_ONLY_TEMPLATES.has(template) ? 'icon-only' : 'labelled'
    const isPopoverOpen = store.openFilterPopoverPosition === position
    const popoverPlacement = getPopoverPlacement(template, position)
    const filterRuleGroup = question?.filter?.question
    const hasFilters = countFilterRules(filterRuleGroup) > 0

    const handleRemoveQuestion = () => {
        store.trackChartDeleted(question)
        store.removeQuestionData(question.surveyId, question.questionId)
        store.activeSlide.removeQuestion(position)
    }

    const renderQuestion = () => {
        if (question.chart === 'verbatim') { // for 1x1 see VerbatimChartSlot.jsx
            return (
                <div style={{ height: '100%', width: '100%', padding: 20 }}>
                    <Typography type="h4">{question.questionShortText}</Typography>

                    <div style={{ height: 'calc(100% - 34px)', width: '100%' }}>
                        {[0, 1].map((i) => (
                            <div style={{ width: '100%', height: '50%', position: 'relative' }}>
                                {!question?.chosenCategories.get(i)
                                    ? (
                                        <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }} onClick={() => store.handleOpenVerbatimSettingsModal(i, true, 2, position)}>
                                            <div className="pp-add-slide">
                                                <i className="fas fa-plus" />
                                            </div>

                                            <Typography>Add category</Typography>
                                        </div>
                                    ) : (
                                        <div className='pp-verbatim-chart-slot-sm' onClick={() => store.handleOpenVerbatimSettingsModal(i, true, 2, position)}>
                                            <Typography type="b">
                                                {question?.chosenCategories.get(i)?.category}
                                            </Typography>

                                            <div className="pp-category-slot">
                                                <div className="pp-chart-slot-option-comment">
                                                    <Typography type="tiny">
                                                        {question?.chosenCategories.get(i)?.labels[0] || ''}
                                                    </Typography>
                                                </div>

                                                <div className="pp-chart-slot-option-comment">
                                                    <Typography type="tiny">
                                                        {question?.chosenCategories.get(i)?.labels[1] || ''}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        ))}
                    </div>
                </div>
            )
        }

        return store.getChart(
            {
                ...data,
                title: '',
                surveyId: question.surveyId,
                surveyDefaultLocale: question.surveyDefaultLocale || data?.surveyDefaultLocale,
                containerSize: { height: 400, width: 450 },
                chartType: question?.chart,
                settings: question.settings,
                position,
            },
            data?.data,
            [...question.comparisonYears, question.year],
        ) || <NoChartData question={question} />
    }

    const handleEdit = () => {
        store.handleEditChart(position)
    }

    const handleFilter = () => {
        store.handleOpenFilterModal(position)
    }

    const handleTogglePopover = () => {
        if (isPopoverOpen) {
            store.closeFilterPopover()
        } else {
            store.setOpenFilterPopover(position)
        }
    }

    return (
        <div className="pp-chart-slot-container">
            <div className="pp-slide-controls">
                {!store.isTemplate && (
                    <div className="pp-filter-pill-anchor">
                        <FilterPill
                            ruleGroup={filterRuleGroup}
                            mode={pillMode}
                            isOpen={isPopoverOpen}
                            onToggle={handleTogglePopover}
                        />
                        {isPopoverOpen && (
                            <FilterBreakdownPopover
                                ruleGroup={filterRuleGroup}
                                placement={popoverPlacement}
                                onClose={store.closeFilterPopover}
                                onEdit={handleFilter}
                            />
                        )}
                    </div>
                )}

                {!store.isTemplate && !hasFilters && (
                    <div className="pp-slide-edit" onClick={handleFilter}>
                        <i className="fas fa-filter" />
                    </div>
                )}

                {question?.chart !== 'verbatim' && (
                    <div className="pp-slide-edit" onClick={handleEdit}>
                        <i className="fas fa-pen-to-square" />
                    </div>
                )}

                <div className="pp-slide-delete" onClick={handleRemoveQuestion}>
                    <i className="fas fa-trash" />
                </div>
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                {question ? renderQuestion() : (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, width: '100%', height: '100%', cursor: 'pointer' }} onClick={store.handleAddQuestion}>
                        <div className="pp-add-on-slide">
                            <i className="far fa-plus" />
                        </div>

                        <Typography>{i18n.t('q_editor_title_add')}</Typography>
                    </div>
                )}
            </div>
        </div>
    )
})

export default ChartSlot
